/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BatchBillResultItem
 */
export interface BatchBillResultItem {
    /**
     * 订单编码
     * @type {string}
     * @memberof BatchBillResultItem
     */
    orderCode?: string;
    /**
     * 新创建账单的ID
     * @type {number}
     * @memberof BatchBillResultItem
     */
    billId?: number;
}

/**
 * Check if a given object implements the BatchBillResultItem interface.
 */
export function instanceOfBatchBillResultItem(value: object): value is BatchBillResultItem {
    return true;
}

export function BatchBillResultItemFromJSON(json: any): BatchBillResultItem {
    return BatchBillResultItemFromJSONTyped(json, false);
}

export function BatchBillResultItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): BatchBillResultItem {
    if (json == null) {
        return json;
    }
    return {
        
        'orderCode': json['orderCode'] == null ? undefined : json['orderCode'],
        'billId': json['billId'] == null ? undefined : json['billId'],
    };
}

export function BatchBillResultItemToJSON(json: any): BatchBillResultItem {
    return BatchBillResultItemToJSONTyped(json, false);
}

export function BatchBillResultItemToJSONTyped(value?: BatchBillResultItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderCode': value['orderCode'],
        'billId': value['billId'],
    };
}

